<template>
  <div>
    <custom-callout
      :has-toggle="true"
      :controlled="true"
      :opened="isOpen"
      class="mt-2"
      :border-color="getStatusColor(value.status)"
      @click:open="toggleAdditionalInfo()"
    >
      <div class="row mt-2 pb-3">
        <div
          :class="[
            'col-md-2',
            { 'pt-3 pl-q': !isMobile, 'col-8 pt-2': isMobile },
          ]"
        >
          <div class="row h-50">
            <div>
              <custom-balloon
                class="px-3"
                :text="value.status"
                :background-color="getStatusColor(value.status)"
              />
            </div>
          </div>
          <div class="row mt-1">
            <div class="col">
              <div class="info-text-title">
                {{ value.studentSieId }}
              </div>
              <p class="info-text">
                {{ value.studentName }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-8 pt-3 grey-divider">
          <div :class="['row', { 'pt-2': isMobile }]">
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Título:
              </div>
              <p class="info-text">
                {{ value.title }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Materia:
              </div>
              <p class="info-text">
                {{ value.subject }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Grado:
              </div>
              <p class="info-text">
                {{ value.grade }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                CSEE:
              </div>
              <p class="info-text">
                {{ value.csee }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Municipio:
              </div>
              <p class="info-text">
                {{ value.municipality }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Escuela:
              </div>
              <p class="info-text">
                {{ value.school }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-2 pt-3">
          <div class="row w-100 custom-button">
            <dropdown
              :class="['w-100', { 'pl-c': isMobile }]"
              name="Actions"
              :title="'Acciones'"
              :items="booksOptions"
            />
          </div>
        </div>
      </div>
    </custom-callout>
    <a
      :ref="
        `ei-collapse-${value.bookId}-${value.academicYearId}-${value.studentSieId}`
      "
      class="hidden"
      data-toggle="collapse"
      :href="
        `#ei-collapse-${value.bookId}-${value.academicYearId}-${value.studentSieId}`
      "
      aria-expanded="false"
      :aria-controls="
        `ei-collapse-${value.bookId}-${value.academicYearId}-${value.studentSieId}`
      "
    />
    <template>
      <div
        :id="
          `ei-collapse-${value.bookId}-${value.academicYearId}-${value.studentSieId}`
        "
        class="collapse additional-container"
      >
        <div class="p-2 mt-1">
          <div class="row">
            <div class="col-12">
              <div :class="['bg-white p-3 rounded', { 'pl-c-xl': !isMobile }]">
                <determine-book
                  v-if="isVisible"
                  v-model="value"
                  :collections="collections"
                  @cancel-determine-book="hideDetermineBook"
                />
                <template v-else>
                  <span>
                    <i class="fa fa-info-circle mr-2 orange" />
                    <span class="title">Información Adicional del Libro</span>
                  </span>
                  <div class="row mt-2 pb-3">
                    <div class="col-md-12 pt-3">
                      <div class="row mobile-row">
                        <div class="col-md-4 col-6">
                          <div class="info-text-title">
                            Autor:
                          </div>
                          <p class="info-text">
                            {{ value.author ? value.author : '-' }}
                          </p>
                        </div>
                        <div class="col-md-4 col-6">
                          <div class="info-text-title">
                            ISBN:
                          </div>
                          <p class="info-text">
                            {{ value.isbn ? value.isbn : '-' }}
                          </p>
                        </div>
                        <div class="col-md-4 col-6">
                          <div class="info-text-title">
                            Casa Editora:
                          </div>
                          <p class="info-text">
                            {{ value.publisher ? value.publisher : '-' }}
                          </p>
                        </div>
                        <div class="col-md-4 col-6">
                          <div class="info-text-title">
                            Fecha de Pedido:
                          </div>
                          <p class="info-text">
                            {{ value.requestDate ? value.requestDate : '-' }}
                          </p>
                        </div>
                        <div class="col-md-4 col-6">
                          <div class="info-text-title">
                            Tipo de Pedido:
                          </div>
                          <p class="info-text">
                            {{ value.requested ? 'Si' : 'No' }}
                          </p>
                        </div>
                        <div class="col-md-4 col-6">
                          <div class="info-text-title">
                            Razón:
                          </div>
                          <p class="info-text">
                            {{
                              value.requestReason ? value.requestReason : '-'
                            }}
                          </p>
                        </div>
                        <div class="col-md-4 col-6">
                          <div class="info-text-title">
                            Medio de Lectura:
                          </div>
                          <p class="info-text">
                            {{
                              value.readingMedium ? value.readingMedium : '-'
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import store from '@/store/index';
import CustomCallout from 'custom-callout';
import CustomBalloon from 'custom-balloon';
import dropdown from 'dropdown';
import { Colors } from '@/components/common';
import moment from 'moment';
import DetermineBook from './DetermineBook.vue';

export default {
  name: 'SearchResultRow',
  components: {
    CustomCallout,
    CustomBalloon,
    dropdown,
    DetermineBook,
  },
  data() {
    return {
      booksOptions: [
        {
          label: 'Determinar',
          icon: 'fas fa-edit color-primary-1',
          click: () => this.showDetermineBook(),
        },
      ],
      isOpen: false,
      isVisible: false,
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    collections: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isMobile() {
      return store.getters.getIsMobileDensity;
    },
    getStatusColor() {
      return (status) => {
        switch (status) {
          case 'Pendiente de Pedido':
            return Colors.YELLOW;
          case 'Pendiente de Compra':
            return Colors.YELLOW;
          case 'Pendiente de Entrega de Centro':
            return Colors.PINK;
          case 'Pendiente de Entrega de Escuela':
            return Colors.PINK;
          case 'Entregado':
            return Colors.GREEN;
          default:
            return Colors.YELLOW;
        }
      };
    },
  },
  methods: {
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY')
        .replace('.', '');
    },
    toggleAdditionalInfo() {
      let { link, isOpen } = this.getCollapse(this.value.bookId);
      link.click();
      this.isOpen = !isOpen;
    },
    getCollapse() {
      let link = this.$refs[
        `ei-collapse-${this.value.bookId}-${this.value.academicYearId}-${this.value.studentSieId}`
      ];
      const isOpen = link.getAttribute('aria-expanded') == 'true';
      return { link, isOpen };
    },
    close() {
      let { link, isOpen } = this.getCollapse(this.value.bookId);

      if (isOpen) {
        this.isOpen = false;
        link.click();
      }
    },
    showDetermineBook() {
      this.isVisible = true;
    },
    hideDetermineBook() {
      this.isVisible = false;
    },
  },
};
</script>

<style scoped>
.additional-container {
  background-color: #f7f7f7;
  border-radius: 5px;
}

::v-deep .ac-btn:not(:hover) {
  background: transparent !important;
}

.pl-c-xl {
  padding-left: 40px !important;
}

.orange {
  color: #ff7058;
}

::v-deep .custom-button > div > #dropdownMenuButton {
  color: black !important;
  font-weight: 700 !important;
}

.pl-q {
  padding-left: 3rem;
}

::v-deep button#dropdownMenuButton {
  background: transparent !important;
}

::v-deep .dropdown-menu.dropdown-menu-right {
  width: 100% !important;
}

.radio-button-container {
  height: 100%;
  align-items: unset !important;
}

.radio-button-container >>> .custom-radio-button {
  margin-right: 0;
  margin-left: 8px;
  background-color: #e2e2e2 !important;
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.buttons-mobile {
  display: none;
}

@media only screen and (max-width: 375px) {
  ::v-deep .ac-btn {
    width: 100%;
  }

  .grey-divider::before {
    content: '';
    position: absolute;
    left: 49%;
    margin-left: -43%;
    width: 85%;
    height: 1px;
    background: #b5c3bc;
    margin-top: -10px;
  }

  .pl-c {
    margin-left: 15px;
  }
  .selct-text {
    display: none;
  }

  .fa-check {
    margin-right: 0px !important;
  }

  .buttons-mobile {
    display: flex;
  }

  .lg-btn {
    width: 100%;
  }

  .buttons-full {
    display: none;
  }

  ::v-deep .info-text-title {
    color: #727272 !important;
    font-size: 12px !important;
    font-weight: normal !important;
  }

  ::v-deep .info-text {
    color: #11291b !important;
    font-weight: normal !important;
    font-size: 12px !important;
  }

  ::v-deep .balloon-container {
    font-size: 12px !important;
  }

  .custom-radio-container > span:first-of-type {
    height: 100% !important;
    transform: none;
    top: 38px;
  }
}

::v-deep .info-text-title {
  color: #727272;
  font-size: 16px;
  font-weight: normal;
}

::v-deep .info-text {
  color: #11291b;
  font-weight: bold;
  font-size: 16px;
}

::v-deep .bg-gray {
  background-color: #e2e2e2 !important;
}

::v-deep .bg-green {
  background-color: #2db782 !important;
  border-color: #2db782;
}

::v-deep .radio .cr {
  border: 2px solid #ffffff !important;
}

::v-deep .step-label {
  color: #ffffff !important;
}

::v-deep .step-label-mobile {
  color: #ffffff !important;
}

::v-deep .balloon-container {
  font-size: 16px;
}
</style>
